import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCanada = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 17"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8 16.0107C12.4183 16.0107 16 12.429 16 8.01074C16 3.59246 12.4183 0.0107422 8 0.0107422C3.58172 0.0107422 0 3.59246 0 8.01074C0 12.429 3.58172 16.0107 8 16.0107Z"
      fill="#F0F0F0"
    />
    <path
      d="M15.9998 8.01075C15.9998 4.83907 14.154 2.09857 11.478 0.804565V15.2169C14.154 13.9229 15.9998 11.1824 15.9998 8.01075Z"
      fill="#D80027"
    />
    <path
      d="M0 8.01075C0 11.1824 1.84578 13.9229 4.52175 15.2169V0.804565C1.84578 2.09857 0 4.83907 0 8.01075Z"
      fill="#D80027"
    />
    <path
      d="M9.39119 9.05418L10.7825 8.35852L10.0868 8.01071V7.31505L8.69553 8.01071L9.39119 6.6194H8.69553L7.99988 5.57593L7.30422 6.6194H6.60857L7.30422 8.01071L5.91291 7.31505V8.01071L5.21729 8.35852L6.60857 9.05418L6.26075 9.74983H7.65207V10.7933H8.34769V9.74983H9.739L9.39119 9.05418Z"
      fill="#D80027"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCanada)
const IconSvgCanada = createIcon(ForwardRef, 'SvgCanada')
export default IconSvgCanada
